import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface ResetConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ResetConfirmDialog: React.FC<ResetConfirmDialogProps> = ({ open, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const confirmRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent
        className="revy-ui sm:max-w-md"
        // Radix would otherwise land on the close affordance; the destructive
        // action was the autoFocus target before the port.
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          confirmRef.current?.focus();
        }}
      >
        <DialogHeader>
          <DialogTitle className="revy-cjk leading-[1.5]">
            {t('settings.resetConfirmTitle')}
          </DialogTitle>
          <DialogDescription className="revy-cjk leading-[1.7]">
            {t('settings.resetConfirmQuestion')}
            <br />
            <br />
            {t('settings.resetConfirmDescription')}
            <br />
            <br />
            <strong>{t('settings.irreversible')}</strong>
          </DialogDescription>
        </DialogHeader>

        {/* DialogFooter reverses below sm; MUI's DialogActions stayed a row. */}
        <DialogFooter className="flex-row justify-end gap-2 sm:space-x-0">
          <Button variant="ghost" onClick={onCancel} className="revy-cjk">
            {t('common.cancel')}
          </Button>
          <Button
            ref={confirmRef}
            onClick={onConfirm}
            className="revy-cjk bg-warning text-warning-foreground hover:bg-warning/90"
          >
            {t('settings.executeReset')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ResetConfirmDialog;
